import { Component } from '@angular/core';

@Component({
  selector: 'io-provetech-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'user';
}
